/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @author Andrey Dubov
 * @author Alexander Golshtein
 * @version 1.24.0
 * @since 1.20.0
 */

import * as Yup from 'yup';

import { getFormLocale } from '@modules/form/const/formLocalization';
import { ICorporateFormTranslation } from '@modules/internationalization/types/corporate';

import { FileId, ICreateInquiryForm, TCreateInquiryFormValidation } from './types';

export enum ECreateInquiryType {
    account = 'ACCOUNT', // для списка ЛС и карточки ЛС
    mobile = 'MOBILE', // для списка МС и карточки МС
    card = 'CARD', // для страницы обращения
}

export enum ECreateInquiryField {
    section = 'section',
    topic = 'topic',
    // additional attributes
    description = 'description',
    phone = 'phone',
    email = 'email',
    // attachment
    file = 'file',
}

export enum ECreateInquiryFieldType {
    string = 'STRING',
    date = 'DATE',
    number = 'NUMBER',
    bool = 'BOOL',
    dictionary = 'DICTIONARY',
    dbQuery = 'DB_QUERY',
}

export enum ECreateInquiryFieldVisibility {
    hidden = 'HIDDEN',
    readOnly = 'READ_ONLY',
    mandatory = 'MANDATORY',
    optional = 'OPTIONAL',
}

export const CreateInquiryInitialValues: ICreateInquiryForm = {
    [ECreateInquiryField.section]: { value: '', label: '' },
    [ECreateInquiryField.topic]: { value: '', label: '' },
    // additional attributes
    [ECreateInquiryField.description]: '',
    [ECreateInquiryField.phone]: '',
    [ECreateInquiryField.email]: '',
    // attachment
    [ECreateInquiryField.file]: new Map<FileId, File>(),
};

export enum ECreateInquiryCustomAttributeCode {
    createMarkerAttributeCode = 'RFC165180_15',
}

export const AttributeDictionaryPageSize = 10;

export const setInitialValidationScheme = (translation: ICorporateFormTranslation['validation']): TCreateInquiryFormValidation => {
    Yup.setLocale(getFormLocale(translation));

    return ({
        section: Yup.object().shape({ value: Yup.string().required() }),
        topic: Yup.object().shape({ value: Yup.string().required() }),
    })
};
